import { Component } from '@angular/core';
import { HomeFitDetails } from '../../components/home/home-fit-details/home-fit-details';
import { HomeFitPhilosophy } from '../../components/home/home-fit-philosophy/home-fit-philosophy';
import { HomeHero } from '../../components/home/home-hero/home-hero';
import { HomeNewArrivals } from '../../components/home/home-new-arrivals/home-new-arrivals';
import { HomeNewsletterSignup } from '../../components/home/home-newsletter-signup/home-newsletter-signup';
import { HomeShopByMovement } from '../../components/home/home-shop-by-movement/home-shop-by-movement';
import { TitleService } from '../../services/title.service';
@Component({
  selector: 'app-home-page',
  imports: [
    HomeHero,
    HomeFitPhilosophy,
    HomeShopByMovement,
    HomeFitDetails,
    HomeNewArrivals,
    HomeNewsletterSignup,
  ],
  templateUrl: './home-page.html',
  styleUrl: './home-page.scss',
})
export class HomePage {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('');
  }
}
